import { getRequest, postRequest } from "../../utils/apiHelper";
import {
  setAppointments,
  appendAppointments,
  setError,
  setLoading,
  clearAllTabs,
} from "./dashboardSlice";

// Mapping of tabs to appointment status IDs
const TAB_STATUS_MAP = {
  active: [21, 23, 28],
  scheduled: [22],
  closed: [24, 25, 26],
};

// API call to get appointments by technician ID
export const getAppointmentsByTechIdAPI =
  (technicianId, input, loadMore = false) =>
  async (dispatch, getState) => {
    const { activeTab } = getState().dashboard;
    try {
      if (!loadMore) dispatch(setLoading({ loading: true, tab: activeTab }));

      const requestData = {
        pageNo: input.pageNo || 1,
        pageSize: input.pageSize || 10,
        searchQuery: input.searchQuery || "",
        startDate: input.startDate || null,
        endDate: input.endDate || null,
        statusFilter: TAB_STATUS_MAP[input.tab] || null,
      };

      const res = await postRequest(
        `api/Appointment/GetAppointmentsByTechId?TechnicianId=${technicianId}`,
        requestData
      );

      const responseData = {
        items: res?.data?.items || [],
        pageNumber: res?.data?.pageNumber || 1,
        totalPages: res?.data?.totalPages || 0,
        totalItems: res?.data?.totalItems || 0,
        tab: input.tab,
      };

      if (loadMore) {
        dispatch(appendAppointments(responseData));
      } else {
        dispatch(setAppointments(responseData));
      }
    } catch (e) {
      const errorMessage =
        e?.response?.data?.Message ||
        e?.message ||
        "Failed to load appointments";
      dispatch(setError({ error: errorMessage, tab: activeTab }));
      console.error("Dashboard.Error:", errorMessage);
    } finally {
      if (!loadMore) dispatch(setLoading({ loading: false, tab: activeTab }));
    }
  };

// API call to update appointment status
export const updateAppointmentStatusAPI =
  (appointmentId, newStatus) => (dispatch) => {
    return new Promise((resolve, reject) => {
      debugger;
      try {
        postRequest(
          `api/Appointment/UpdateAppointmentStatus?appointmentId=${appointmentId}&appointmentStatusId=${newStatus}`
        )
          .then((res) => {
            resolve(res);
          })
          .catch((e) => {
            debugger;
            const errorMessage = e?.response?.data || e?.message;
            dispatch(setError(errorMessage));
            reject(e);
          });
      } catch (e) {
        dispatch(
          setError(
            "An unexpected error occurred while updating appointment status"
          )
        );
        reject(e);
      }
    });
  };

// API call to get details of a single appointment
export const getAppointmentDetailsAPI =
  (appointmentId) => async (dispatch, getState) => {
    // Fixed: Added getState
    try {
      const res = await getRequest(
        `api/Appointment/GetAppointmentById?appointmentId=${appointmentId}`
      );
      return res?.data;
    } catch (e) {
      const errorMessage =
        e?.response?.data?.Message ||
        e?.message ||
        "Failed to load appointment details";
      dispatch(
        setError({ error: errorMessage, tab: getState().dashboard.activeTab })
      );
      console.error(
        "Dashboard.Error.FailedToLoadAppointmentDetails:",
        errorMessage
      );
    }
  };
